import React , { useEffect } from 'react';
import css from './index.module.scss'
import $ from "jquery";


export default() => {


  useEffect(() => {


    $(window).scroll(function() {
      const scrollTop = $(window).scrollTop()

         if($(window).scrollTop() === 0){
          $(`.${css.header}`).removeClass(css.onScrollDown)
          $(`.${css.header}`).removeClass(css.onScrollUp)
         }
         setTimeout(() => {
           const newScrollTop = $(window).scrollTop()
           if(newScrollTop > scrollTop){
            $(`.${css.header}`).removeClass(css.onScrollUp)
             $(`.${css.header}`).addClass(css.onScrollDown)
           }

          if($(window).scrollTop() === 0){
            $(`.${css.header}`).removeClass(css.onScrollDown)
            $(`.${css.header}`).removeClass(css.onScrollUp)
           }
         },50);

    })

  }, [])

    return(
    <header className = {css.header}>
        <img alt = 'logo' src = {require('./logo.png')} />


    </header>
    )
}
